import {useTranslation} from "react-i18next";
import clsx from "clsx";
import PropTypes from "prop-types";

import useRoutePermissions, {
  UI_PERMISSION_TYPE,
} from "../../Components/adminForms/Ba3aSettings/tabs/PositionsSettings/useRoutePermissions";
import Icon from "../../Components/Icon/Icon";
import {COLOR_SCHEME} from "../colorSheme";
import ToolTip from "../ToolTip";

//* nameIcon: icon name from sprite.svg; add to sprite.svg if missing
//* heightIcon and widthIcon: The default value is 22px. Values as numbers.
//* You can override these values if needed, or leave the default ones.
//* Note: sizes defined in CSS classes take precedence over prop values.

const IconButton = ({
  tooltipMessage,
  noFunctional = false,
  bottomTooltip = false,
  nameIcon,
  className,
  classNameIcon,
  classNameBtn,
  type = "button",
  onClick = () => {},
  disabled = false,
  ariaLabel,
  heightIcon,
  widthIcon,
  name,
  hidden,
  accented,
  uiPermissionType = UI_PERMISSION_TYPE.WRITABLE,
  ...props
}) => {
  const {t} = useTranslation();
  const tooltipTitle = typeof tooltipMessage === "string" ? t(tooltipMessage) : tooltipMessage;

  const {isDisabledByRoutePermission} = useRoutePermissions({uiPermissionType});

  return (
    <ToolTip
      title={
        noFunctional
          ? t("No functional")
          : isDisabledByRoutePermission
          ? "Your position has no permission for this action"
          : tooltipTitle
      }
      bottom={bottomTooltip}
      className={clsx(className, hidden && "hiddenEl")}
    >
      <button
        aria-label={t(ariaLabel)}
        className={clsx("iconBtn", name && "row widthUnset", classNameBtn)}
        {...props}
        type={type}
        onClick={onClick}
        disabled={isDisabledByRoutePermission || disabled || noFunctional}
      >
        <Icon
          name={nameIcon}
          className={classNameIcon}
          height={heightIcon}
          width={widthIcon}
          style={{...(accented ? {fill: COLOR_SCHEME.ALERT} : {})}}
        />
        {name && (
          <div
            className={clsx(
              "row fixed_button fixed_button__blue autoWidth pl pr",
              disabled && "notAllowedCursor",
              !disabled && "btn-responsive ",
            )}
            style={{display: "flex"}}
          >
            {t(name)}
          </div>
        )}
      </button>
    </ToolTip>
  );
};

IconButton.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  ariaLabel: PropTypes.string,
  className: PropTypes.string,
  onClick: PropTypes.func,
  props: PropTypes.array,
};

export default IconButton;
